import React from "react";
import "../assets/css/error.css";
import { MdArchitecture } from "react-icons/md";
import { AiOutlineDesktop } from "react-icons/ai";
import { GoLaw } from "react-icons/go";
import { GiPlantsAndAnimals } from "react-icons/gi";
import { BiVideoRecording, BiCapsule } from "react-icons/bi";
import { BsGlobe, BsBuilding, BsXDiamond } from "react-icons/bs";
import { RiCalculatorLine } from "react-icons/ri";
import { TbCertificate } from "react-icons/tb";
import { IoIosDesktop } from "react-icons/io";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import { GiCommercialAirplane } from "react-icons/gi";
import { RiPenNibLine } from "react-icons/ri";
import careersLogo from "../assets/images/logo-blue.svg";
import {Helmet} from "react-helmet";
const NotFound = () => {
  return (
    <>
      <Helmet>
          <title>404 Page Not FOund</title>
      </Helmet>

      <div className={"header_border"}>
        <a href="https://www.careers360.com/">
          <img
            src={careersLogo}
            alt="Careers360 Logo"
            width={166}
            height={20}
          />
        </a>
      </div>

      <div className="not_found">
        <div className="container">
        <img src={require("../assets/images/error_404.png")} alt="" />
          
          <h1>Page Not Found</h1>
          <h4>
            Check that you typed the address correctly, go back to your previous
            page or try using out site search to find something specific
          </h4>
          <div className="button_card">
            <a href="https://careers360.com" className="btn_active">
              Go to Homepage
            </a>
          </div>
          <h5>Here are a few links that might be helpful:</h5>
          <div className="domains_card_cover">
            <div className="domains_card">
              <a href="https://engineering.careers360.com/">
                <span>
                  <MdArchitecture />
                </span>
                <p>Engineering and Architecture</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://bschool.careers360.com/">
                <span>
                  <AiOutlineDesktop />
                </span>
                <p>Management and Business Administration</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://law.careers360.com/">
                <span>
                  <GoLaw />
                </span>
                <p>Law</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://design.careers360.com/">
                <span>
                  <GiPlantsAndAnimals />
                </span>
                <p>Animation and Design</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://media.careers360.com/">
                <span>
                  <BiVideoRecording />
                </span>
                <p>Media, Mass Communication and Journalism</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://medicine.careers360.com/">
                <span>
                  <BiCapsule />
                </span>
                <p>Medicine and Allied Sciences</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://university.careers360.com/">
                <span>
                  <BsGlobe />
                </span>
                <p>Arts, Humanities and Social Sciences</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://finance.careers360.com/">
                <span>
                  <RiCalculatorLine />
                </span>
                <p>Commerce</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://it.careers360.com/">
                <span>
                  <IoIosDesktop />
                </span>
                <p>Computer Application and IT</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://pharmacy.careers360.com/">
                <span>
                  <MdOutlineLocalPharmacy />
                </span>
                <p>Pharmacy</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://hospitality.careers360.com/">
                <span>
                  <GiCommercialAirplane />
                </span>
                <p>Hospitality and Tourism</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://competition.careers360.com/">
                <span>
                  <RiPenNibLine />
                </span>
                <p>Competition</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://school.careers360.com/">
                <span>
                  <BsBuilding />
                </span>
                <p>Schools</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://www.careers360.com/courses-certifications/all-courses">
                <span>
                  <TbCertificate />
                </span>
                <p>Certifications</p>
              </a>
            </div>
            <div className="domains_card">
              <a href="https://www.careers360.com/premium">
                <span>
                  <BsXDiamond />
                </span>
                <p>Careers360 Premium</p>
              </a>
            </div>
          </div>
          <ul>
            <li>
              <a href="https://www.careers360.com/college-predictor">
                College Predictor
              </a>
            </li>
            <li>
              <a href="https://www.careers360.com/rank-predictor">
                Rank Predictor
              </a>
            </li>
            <li>
              <a href="https://www.careers360.com/colleges/india-colleges-fctp">
                Colleges
              </a>
            </li>
            <li>
              <a href="https://www.careers360.com/application-forms/colleges">
                Applications Open
              </a>
            </li>
            <li>
              <a href="https://www.careers360.com/qna">QnA</a>
            </li>
            <li>
              <a href="https://www.careers360.com/articles">Articles</a>
            </li>
            <li>
              <a href="https://news.careers360.com/">News</a>
            </li>
            <li>
              <a href="https://www.careers360.com/courses-certifications/online-degree-diploma-courses">
                Online Degree
              </a>
            </li>
            <li>
              <a href="https://www.careers360.com/download/ebooks-and-sample-papers">
                E-Books
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default NotFound;